<script setup lang="ts">
import { useRouter } from 'vue-router';

import type { NuxtError } from '#app';

import Error500 from './components/error/500.vue';
import Fallback from './components/error/fallback.vue';

const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError
});

const router = useRouter();

const onRefresh = (): void => {
  window.location.reload();
};

const onGoHome = async (): Promise<void> => {
  await router.push({ name: 'index' });
};

const onGoBack = (): void => {
  router.back();
};
</script>

<template>
  <div class="w-dvw h-dvh">
    <Error500
      v-if="props.error?.statusCode === 500"
      @refresh="onRefresh"
    />
    <Fallback
      v-else
      :status-code="props.error?.statusCode"
      @go-home="onGoHome()"
      @go-back="onGoBack"
    />
  </div>
</template>
